import { Alert } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { PropsWithChildren } from "react";
import { RuntimeConfig } from "tng-address-collection-shared/types";
import { z } from "zod/v4";
import { useTranslator } from "../i18n/translator";
import { RuntimeConfigContext } from "./RuntimeConfigContext";

const runtimeConfigParser = z.object({
  idpConfig: z.object({
    authority: z.string().nonempty(),
    clientId: z.string().nonempty(),
  }),
  isTestSystem: z.boolean(),
  appUrls: z.object({
    addressCollection: z.url(),
    portraits: z.url(),
  }),
}) satisfies z.ZodType<RuntimeConfig>;

export const RuntimeConfigProvider = ({ children }: PropsWithChildren) => {
  const translate = useTranslator();
  const {
    data: runtimeConfig,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["AUTH_CONFIG"],
    queryFn: async () => {
      const response = await fetch("/config.json");
      return runtimeConfigParser.parse(await response.json());
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });

  if (isLoading) {
    return null;
  }

  if (isError || !runtimeConfig) {
    return (
      <Alert severity="error">{translate("errorLoadingLoginConfig")}</Alert>
    );
  }

  return (
    <RuntimeConfigContext.Provider value={runtimeConfig}>
      {children}
    </RuntimeConfigContext.Provider>
  );
};
